<template>
  <div class="cloud-info-dialog" v-show="cloudInfo.visible"
    :style="{ left: cloudInfo.x + 'px', top: cloudInfo.y + 'px' }">
    <div class="cloud-info-header">
      <span class="cloud-info-title">云量信息</span>
      <span class="cloud-info-close" @click="$emit('close')">&times;</span>
    </div>
    <div class="cloud-info-body">
      <p><span class="label">纬度：</span><span class="value">{{ cloudInfo.lat.toFixed(4) }}°</span></p>
      <p><span class="label">经度：</span><span class="value">{{ cloudInfo.lng.toFixed(4) }}°</span></p>
      <p>
        <span class="label">云量：</span>
        <span class="value cloud-percent">{{ cloudInfo.percent }}%</span>
      </p>
    </div>
  </div>

  <!-- 鼠标悬浮云图实时提示 -->
  <div v-show="cursorTip.visible" class="cursor-tip" :style="{ left: cursorTip.x + 'px', top: cursorTip.y + 'px' }">
    <div>纬度：{{ cursorTip.lat.toFixed(4) }}°</div>
    <div>经度：{{ cursorTip.lng.toFixed(4) }}°</div>
    <div>云量：<span class="tip-percent">{{ cursorTip.percent }}%</span></div>
  </div>
</template>

<script setup>
defineProps({
  cloudInfo: {
    type: Object,
    required: true
  },
  cursorTip: {
    type: Object,
    required: true
  }
});

defineEmits(['close']);
</script>

<style scoped>
/* 鼠标悬浮云图实时提示 */
.cursor-tip {
  position: fixed;
  z-index: 9998;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.78);
  color: #fff;
  font-size: 12px;
  line-height: 1.6;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: nowrap;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.cursor-tip .tip-percent {
  color: #4ed7ff;
  font-weight: 600;
}

/* 云量信息弹窗 */
.cloud-info-dialog {
  position: fixed;
  z-index: 9999;
  width: 260px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  user-select: none;
}

.cloud-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}

.cloud-info-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.cloud-info-close {
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  color: #909399;
}

.cloud-info-close:hover {
  color: #303133;
}

.cloud-info-body {
  padding: 10px 14px;
}

.cloud-info-body p {
  margin: 8px 0;
  font-size: 14px;
  line-height: 1.8;
  display: flex;
  align-items: center;
}

.cloud-info-body .label {
  color: #666;
  min-width: 50px;
}

.cloud-info-body .value {
  color: #222;
  font-weight: 600;
  font-family: 'Courier New', monospace;
}

.cloud-info-body .cloud-percent {
  color: #1890ff;
  font-size: 18px;
}
</style>
